<div class="container mt-5">
  <div class="row">
    <div class="col-7 mx-auto ">
      <div class="card flex-row my-5 border-0 shadow">
        <div class="card-body p-4 p-sm-5">
          <div class="d-flex justify-content-center">
            <img src="./assets/identity/logo.png" style="width: 30%;">
            <!-- <h3 class="card-title text-start mb-4 ">Login</h3> -->
          </div>
          <hr>
          <form [formGroup]="formForget" (ngSubmit)="onForget()">
            <div class="form-group" style="text-align: start;">
              <label for="email" class="d-flex justify-content-between">
                {{'email' | translate}}
              </label>
              <input type="email"  [placeholder]="'email-hint' | translate:{ company: companyName }"  formControlName="email" class="form-control" />
            </div>
            <div class="d-flex justify-content-between">
              <label>
                <a class="text-dark" (click)="login()">{{"back"|translate}}</a>
              </label>
              <button [disabled]="formForget.invalid || formForget.pristine" class="btn btn-primary">
                {{"send"|translate}}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</div>
